(function () {
  var config = window.BFLVisitorBehaviorConfig || {};
  if (!config || config.enabled === false) return;
  if (/^\/admin(?:\/|$)/.test(window.location.pathname)) return;
  if (navigator.webdriver === true) return;
  if (/bot|crawl|spider|headless|lighthouse|prerender/i.test(navigator.userAgent || "")) return;

  var endpoint = String(config.endpoint || "/apps/appointments/behavior-events");
  var whatsappLeadClickEndpoint = String(config.whatsappLeadClickEndpoint || "/apps/appointments/whatsapp-clicks");
  var sampleRate = clampNumber(config.sampleRate, 1, 0, 1);
  var started = false;
  var queue = [];
  var flushTimer = 0;
  var scrollMarks = {};
  var sessionKey = "";
  var visitorId = "";
  var userAgentHash = "";
  var firstPath = safePath(window.location.href);
  var referrerPath = sameHostReferrerPath();
  var acquisition = firstTouchAcquisition();
  var consentReadyTimeout = 0;
  var metaWhatsappEventName = cleanMetaEventName(config.metaWhatsappEventName || "Contact");
  var metaWhatsappContactValue = clampNumber(config.metaWhatsappContactValue, 1, 0.01, 100000);
  var metaWhatsappContactCurrency = cleanCurrency(config.metaWhatsappContactCurrency || "USD") || "USD";

  function clampNumber(value, fallback, min, max) {
    var parsed = Number(value);
    if (!Number.isFinite(parsed)) return fallback;
    return Math.max(min, Math.min(max, parsed));
  }

  function randomId(prefix) {
    var bytes = new Uint8Array(12);
    if (window.crypto && typeof window.crypto.getRandomValues === "function") {
      window.crypto.getRandomValues(bytes);
      return prefix + Array.from(bytes).map(function (value) {
        return value.toString(16).padStart(2, "0");
      }).join("");
    }
    return prefix + String(Date.now()) + String(Math.random()).slice(2);
  }

  function safeStorage(storage, key, fallbackFactory) {
    try {
      var existing = storage.getItem(key);
      if (existing) return existing;
      var next = fallbackFactory();
      storage.setItem(key, next);
      return next;
    } catch (_error) {
      return fallbackFactory();
    }
  }

  function safePath(value) {
    try {
      var url = new URL(String(value || window.location.href), window.location.origin);
      var params = new URLSearchParams();
      url.searchParams.forEach(function (paramValue, key) {
        var normalizedKey = String(key || "").toLowerCase();
        if (
          normalizedKey === "page" ||
          normalizedKey === "sort_by" ||
          normalizedKey === "variant" ||
          normalizedKey.indexOf("filter.") === 0
        ) {
          params.set(normalizedKey, String(paramValue || "").slice(0, 80));
        }
      });
      var query = params.toString();
      return url.pathname + (query ? "?" + query : "");
    } catch (_error) {
      return window.location.pathname || "/";
    }
  }

  function sameHostReferrerPath() {
    if (!document.referrer) return "";
    try {
      var referrer = new URL(document.referrer);
      if (referrer.host !== window.location.host) return "";
      return safePath(referrer.href);
    } catch (_error) {
      return "";
    }
  }

  function externalReferrerHost() {
    if (!document.referrer) return "";
    try {
      var referrer = new URL(document.referrer);
      if (referrer.host === window.location.host) return "";
      return cleanHost(referrer.hostname);
    } catch (_error) {
      return "";
    }
  }

  function cleanHost(value) {
    var host = String(value || "").trim().toLowerCase().replace(/^www\./, "");
    return /^[a-z0-9.-]{1,120}$/.test(host) ? host : "";
  }

  function cleanCampaignValue(value, maxLength) {
    var raw = String(value || "");
    if (/^bfl-meta-[0-9]{6,30}$/.test(raw)) return raw;
    if (/([a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}|\+?\d[\d\s().-]{7,}\d)/i.test(raw)) return "";
    var text = raw
      .replace(/[\r\n\t<>]/g, " ")
      .replace(/[^a-zA-Z0-9_.:+/\s-]/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, maxLength);
    if (!text) return "";
    return text;
  }

  function hasPaidClickId(url) {
    return ["gclid", "gbraid", "wbraid", "fbclid", "ttclid", "msclkid"].some(function (key) {
      return url.searchParams.has(key) && String(url.searchParams.get(key) || "").trim();
    });
  }

  function sourceKey(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/^https?:\/\//, "")
      .replace(/^www\./, "")
      .split("/")[0]
      .replace(/[^a-z0-9_.:-]/g, "_")
      .slice(0, 120);
  }

  function sourceName(value) {
    var key = sourceKey(value);
    if (!key) return "";
    if (/google/.test(key)) return "Google";
    if (/instagram/.test(key)) return "Instagram";
    if (/(facebook|fb\.com)/.test(key)) return "Facebook";
    if (/meta/.test(key)) return "Meta";
    if (/tiktok/.test(key)) return "TikTok";
    if (/pinterest/.test(key)) return "Pinterest";
    if (/youtube/.test(key)) return "YouTube";
    if (/bing/.test(key)) return "Bing";
    if (/duckduckgo/.test(key)) return "DuckDuckGo";
    if (/yahoo/.test(key)) return "Yahoo";
    return key.replace(/[_:]+/g, ".").replace(/^\.+|\.+$/g, "").slice(0, 80);
  }

  function classifySource(utmSource, utmMedium, referrerHost, paidClick) {
    var key = sourceKey(utmSource || referrerHost);
    var medium = sourceKey(utmMedium);
    var isPaid = paidClick || /(^|[_-])(cpc|ppc|paid|paid_social|display|ads?|shopping|retargeting)([_-]|$)/.test(medium);
    if (isPaid) {
      if (/google/.test(key)) return { type: "paid", name: "Google Ads" };
      if (/(facebook|fb\.com|instagram|meta)/.test(key)) return { type: "paid", name: "Meta Ads" };
      if (/tiktok/.test(key)) return { type: "paid", name: "TikTok Ads" };
      return { type: "paid", name: sourceName(key) ? sourceName(key) + " Ads" : "Paid" };
    }
    if (/(whatsapp|wa\.me|wa\.link|api\.whatsapp\.com)/.test(key)) return { type: "whatsapp", name: "WhatsApp" };
    if (/(instagram|facebook|fb\.com|meta|tiktok|pinterest|youtube|snapchat|linkedin)/.test(key)) return { type: "social", name: sourceName(key) };
    if (/(google|bing|yahoo|duckduckgo|ecosia|yandex|baidu)/.test(key)) return { type: "organic_search", name: sourceName(key) };
    if (referrerHost) return { type: "referral", name: sourceName(referrerHost) };
    if (utmSource) return { type: "referral", name: sourceName(utmSource) };
    return { type: "direct", name: "" };
  }

  function firstTouchAcquisition() {
    var url;
    try {
      url = new URL(window.location.href);
    } catch (_error) {
      url = new URL(window.location.pathname || "/", window.location.origin);
    }
    var referrerHost = externalReferrerHost();
    var utmSource = cleanCampaignValue(url.searchParams.get("utm_source"), 80);
    var utmMedium = cleanCampaignValue(url.searchParams.get("utm_medium"), 60);
    var utmCampaign = cleanCampaignValue(url.searchParams.get("utm_campaign"), 120);
    var utmContent = cleanCampaignValue(url.searchParams.get("utm_content"), 120);
    var paidClick = hasPaidClickId(url);
    var classified = classifySource(utmSource, utmMedium, referrerHost, paidClick);
    return {
      sourceType: classified.type,
      sourceName: classified.name,
      referrerHost: referrerHost,
      utmSource: utmSource,
      utmMedium: utmMedium,
      utmCampaign: utmCampaign,
      utmContent: utmContent,
      hasPaidClickId: paidClick
    };
  }

  // Keep the most recent explicit acquisition during internal navigation in this tab.
  // Called only after analytics consent. Expire after 30 minutes of inactivity.
  function restoreSessionAcquisition() {
    var key = "bfl_behavior_acquisition_v1";
    var now = Date.now();
    try {
      var saved = JSON.parse(window.sessionStorage.getItem(key) || "null");
      var internal = Boolean(referrerPath);
      var explicit = Boolean(acquisition.utmSource || acquisition.utmMedium || acquisition.utmCampaign || acquisition.hasPaidClickId || acquisition.referrerHost);
      if (!explicit && internal && saved && saved.acquisition && now - saved.updatedAt < 30 * 60 * 1000 && now >= saved.updatedAt) {
        acquisition = saved.acquisition;
      }
      window.sessionStorage.setItem(key, JSON.stringify({ updatedAt: now, acquisition: acquisition }));
    } catch (_error) {}
  }

  function deviceType() {
    var width = window.innerWidth || document.documentElement.clientWidth || 0;
    if (width < 720) return "mobile";
    if (width < 1024) return "tablet";
    return "desktop";
  }

  // Libellé appareil lisible (marque/OS), sans version ni détail identifiant.
  function deviceLabel() {
    var ua = String(window.navigator.userAgent || "");
    if (/iPhone/i.test(ua)) return "iPhone";
    if (/iPad/i.test(ua) || (/Macintosh/i.test(ua) && "ontouchend" in document)) return "iPad";
    if (/Android/i.test(ua)) {
      var model = ua.match(/;\s*([^;)]+?)\s+Build\//);
      var name = model ? model[1].replace(/[_]/g, " ").trim() : "";
      if (name && !/^Android/i.test(name)) return ("Android · " + name).slice(0, 40);
      return "Android";
    }
    if (/Windows/i.test(ua)) return "Windows";
    if (/Macintosh|Mac OS X/i.test(ua)) return "Mac";
    if (/CrOS/i.test(ua)) return "Chromebook";
    if (/Linux/i.test(ua)) return "Linux";
    return "";
  }

  function viewport() {
    return {
      width: Math.max(0, Math.round(window.innerWidth || document.documentElement.clientWidth || 0)),
      height: Math.max(0, Math.round(window.innerHeight || document.documentElement.clientHeight || 0))
    };
  }

  function hashUserAgent() {
    var text = String(window.navigator.userAgent || "");
    var hash = 0;
    for (var index = 0; index < text.length; index += 1) {
      hash = ((hash << 5) - hash + text.charCodeAt(index)) | 0;
    }
    return "ua:" + Math.abs(hash);
  }

  function baseEvent(type, data) {
    var detail = data || {};
    return {
      eventId: cleanEventId(detail.eventId) || randomId("evt_"),
      type: type,
      occurredAt: new Date().toISOString(),
      path: safePath(detail.path || window.location.href),
      pageType: cleanToken(detail.pageType || config.pageType || ""),
      productHandle: cleanHandle(detail.productHandle || config.productHandle || ""),
      collectionHandle: cleanHandle(detail.collectionHandle || config.collectionHandle || ""),
      locale: cleanLocale(detail.locale || config.locale || document.documentElement.lang || ""),
      countryCode: cleanCountry(detail.countryCode || config.countryCode || ""),
      market: cleanToken(detail.market || config.market || ""),
      currency: cleanCurrency(detail.currency || config.currency || ""),
      deviceType: deviceType(),
      deviceLabel: deviceLabel(),
      viewport: viewport(),
      scrollPercent: typeof detail.scrollPercent === "number" ? detail.scrollPercent : null,
      xRatio: typeof detail.xRatio === "number" ? detail.xRatio : null,
      yRatio: typeof detail.yRatio === "number" ? detail.yRatio : null,
      target: detail.target || null,
      isDeadClick: Boolean(detail.isDeadClick),
      metadata: sanitizeMetadata(detail.metadata)
    };
  }

  function cleanToken(value) {
    return String(value || "").trim().replace(/[^a-zA-Z0-9_.:-]/g, "_").slice(0, 80);
  }

  function cleanHandle(value) {
    return String(value || "").trim().toLowerCase().replace(/[^a-z0-9-]/g, "").slice(0, 120);
  }

  function cleanLocale(value) {
    var raw = String(value || "").trim().toLowerCase();
    return /^[a-z]{2}(-[a-z]{2})?$/.test(raw) ? raw : "";
  }

  function cleanCountry(value) {
    var raw = String(value || "").trim().toUpperCase();
    return /^[A-Z]{2}$/.test(raw) ? raw : "";
  }

  function cleanCurrency(value) {
    var raw = String(value || "").trim().toUpperCase();
    return /^[A-Z]{3}$/.test(raw) ? raw : "";
  }

  function cleanEventId(value) {
    return String(value || "").trim().replace(/[^a-zA-Z0-9_.:-]/g, "").slice(0, 80);
  }

  function cleanMetaEventName(value) {
    var raw = String(value || "").trim();
    return raw === "Lead" ? "Lead" : "Contact";
  }

  function metaTrackingAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy) return true;
      if (typeof privacy.analyticsProcessingAllowed === "function" && !privacy.analyticsProcessingAllowed()) return false;
      if (typeof privacy.marketingAllowed === "function" && !privacy.marketingAllowed()) return false;
    } catch (_error) {
      return false;
    }
    return true;
  }

  function metaWhatsappContentName() {
    if (config.productHandle) return cleanToken("product:" + config.productHandle);
    if (config.collectionHandle) return cleanToken("collection:" + config.collectionHandle);
    return cleanToken(config.pageType || "storefront") || "storefront";
  }

  function trackMetaWhatsappContact(eventId, attempt) {
    var safeEventId = cleanEventId(eventId);
    var retry = Number(attempt || 0);
    if (!safeEventId || !metaWhatsappEventName || !metaTrackingAllowed()) return;
    if (typeof window.fbq !== "function") {
      if (retry < 6) {
        window.setTimeout(function () {
          trackMetaWhatsappContact(safeEventId, retry + 1);
        }, 250);
      }
      return;
    }
    var customData = {
      content_category: "whatsapp_site_contact",
      content_name: metaWhatsappContentName(),
      source: "site_whatsapp_click",
      value: metaWhatsappContactValue,
      currency: metaWhatsappContactCurrency
    };
    window.fbq("track", metaWhatsappEventName, customData, { eventID: safeEventId });
  }

  function readCookie(name) {
    var prefix = String(name || "") + "=";
    var parts = String(document.cookie || "").split(";");
    for (var i = 0; i < parts.length; i += 1) {
      var part = parts[i].trim();
      if (part.indexOf(prefix) === 0) return part.slice(prefix.length);
    }
    return "";
  }

  function currentFbclid() {
    try {
      var url = new URL(window.location.href);
      return String(url.searchParams.get("fbclid") || "").trim().slice(0, 300);
    } catch (_error) {
      return "";
    }
  }

  function whatsappLeadRefPrefix() {
    var text = [
      config.collectionHandle || "",
      config.productHandle || "",
      window.location.pathname || ""
    ].join(" ").toLowerCase();
    return text.indexOf("fw-2026") >= 0 || text.indexOf("fw2026") >= 0 ? "BFL-FW26-" : "BFL-WA-";
  }

  function buildWhatsappLeadRef() {
    var bytes = new Uint8Array(4);
    var suffix = "";
    if (window.crypto && typeof window.crypto.getRandomValues === "function") {
      window.crypto.getRandomValues(bytes);
      suffix = Array.from(bytes).map(function (value) {
        return value.toString(36).toUpperCase().padStart(2, "0");
      }).join("").replace(/[^A-Z0-9]/g, "").slice(0, 8);
    }
    if (!suffix) suffix = String(Date.now()).slice(-6) + String(Math.random()).slice(2, 4);
    return whatsappLeadRefPrefix() + suffix;
  }

  function appendWhatsappLeadRefToHref(rawHref, leadRef) {
    if (!rawHref || !leadRef) return rawHref;
    try {
      var url = new URL(rawHref, window.location.href);
      var host = String(url.hostname || "").replace(/^www\./, "");
      var canAttachText = url.protocol === "whatsapp:" || host === "wa.me" || host === "api.whatsapp.com" || host === "web.whatsapp.com" || /\.whatsapp\.com$/.test(host);
      if (!canAttachText) return rawHref;
      var existingText = String(url.searchParams.get("text") || "");
      if (existingText.indexOf("BFL-FW26-") >= 0 || existingText.indexOf("BFL-WA-") >= 0) return rawHref;
      var nextText = existingText ? existingText + "\nRef: " + leadRef : "Ref: " + leadRef;
      url.searchParams.set("text", nextText);
      return url.toString();
    } catch (_error) {
      return rawHref;
    }
  }

  function attachWhatsappLeadRefToClick(clickable, leadRef) {
    if (!(clickable instanceof HTMLAnchorElement) || !leadRef) return "";
    var originalHref = clickable.href || String(clickable.getAttribute("href") || "");
    var nextHref = appendWhatsappLeadRefToHref(originalHref, leadRef);
    if (nextHref && nextHref !== originalHref) clickable.href = nextHref;
    return nextHref || originalHref;
  }

  function sendWhatsappLeadClick(leadRef, eventId) {
    if (!leadRef || !whatsappLeadClickEndpoint) return;
    var payload = JSON.stringify({
      shop: config.shop || "",
      leadRef: leadRef,
      eventId: eventId || "",
      visitorId: visitorId,
      sessionKey: sessionKey,
      userAgentHash: userAgentHash,
      fbp: readCookie("_fbp"),
      fbc: readCookie("_fbc"),
      fbclid: currentFbclid(),
      sourceType: acquisition.sourceType,
      sourceName: acquisition.sourceName,
      referrerHost: acquisition.referrerHost,
      utmSource: acquisition.utmSource,
      utmMedium: acquisition.utmMedium,
      utmCampaign: acquisition.utmCampaign,
      utmContent: acquisition.utmContent,
      pagePath: safePath(window.location.href),
      pageType: cleanToken(config.pageType || ""),
      productHandle: cleanHandle(config.productHandle || ""),
      collectionHandle: cleanHandle(config.collectionHandle || ""),
      locale: cleanLocale(config.locale || document.documentElement.lang || ""),
      countryCode: cleanCountry(config.countryCode || ""),
      market: cleanToken(config.market || ""),
      currency: cleanCurrency(config.currency || ""),
      targetHrefPath: "/whatsapp",
      metadata: {
        trackerVersion: "v2",
        generatedBy: "visitor-behavior-tracker"
      }
    });
    fetch(whatsappLeadClickEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: payload,
      keepalive: true
    }).catch(function () {});
  }

  function sanitizeMetadata(input) {
    if (!input || typeof input !== "object" || Array.isArray(input)) return {};
    var allowed = {
      action: true,
      city: true,
      collectionHandle: true,
      currency: true,
      date: true,
      errorCode: true,
      locale: true,
      market: true,
      pageType: true,
      productHandle: true,
      reason: true,
      slotDate: true,
      status: true,
      step: true,
      whatsappLeadRef: true
    };
    var output = {};
    Object.keys(input).forEach(function (key) {
      if (!allowed[key]) return;
      var value = input[key];
      if (typeof value === "string") output[key] = value.replace(/[\r\n\t<>]/g, " ").trim().slice(0, 120);
      if (typeof value === "number" && Number.isFinite(value)) output[key] = Math.max(-10000, Math.min(10000, value));
      if (typeof value === "boolean") output[key] = value;
    });
    return output;
  }

  function clickElement(element) {
    if (!element || !(element instanceof Element)) return null;
    var clickable = element.closest("a,button,summary,[role='button'],[data-behavior-id],input[type='submit']");
    return clickable || element;
  }

  function isWhatsAppHref(value) {
    var raw = String(value || "").trim().toLowerCase();
    if (!raw) return false;
    if (raw.indexOf("whatsapp://") === 0) return true;
    try {
      var url = new URL(raw, window.location.origin);
      var host = String(url.hostname || "").replace(/^www\./, "");
      return host === "wa.me" || host === "wa.link" || host === "api.whatsapp.com" || host === "web.whatsapp.com" || /\.whatsapp\.com$/.test(host);
    } catch (_error) {
      return /(^|[/:.])(wa\.me|wa\.link|api\.whatsapp\.com|web\.whatsapp\.com|whatsapp:\/\/)/.test(raw);
    }
  }

  function isWhatsAppClick(element) {
    var clickable = clickElement(element);
    if (!clickable) return false;
    var href = clickable instanceof HTMLAnchorElement
      ? clickable.href
      : String(clickable.getAttribute("href") || "");
    if (isWhatsAppHref(href)) return true;
    var marker = [
      clickable.getAttribute("data-behavior-id") || "",
      clickable.getAttribute("data-whatsapp") || "",
      clickable.id || "",
      clickable.getAttribute("onclick") || "",
      clickable.getAttribute("aria-label") || "",
      clickable.getAttribute("title") || "",
      clickable.className || ""
    ].join(" ").toLowerCase();
    return marker.indexOf("whatsapp") >= 0;
  }

  function targetInfo(element, forceWhatsapp) {
    var clickable = clickElement(element);
    if (!clickable) return null;
    var href = clickable instanceof HTMLAnchorElement ? clickable.href : "";
    return {
      tag: String(clickable.tagName || "").toLowerCase(),
      role: String(clickable.getAttribute("role") || ""),
      id: String(clickable.getAttribute("data-behavior-id") || ""),
      href: forceWhatsapp ? "/whatsapp" : href ? safePath(href) : ""
    };
  }

  var IMMEDIATE_FLUSH_TYPES = { page_view: 1, whatsapp_intent: 1, appointment_intent: 1, appointment_submit: 1, appointment_success: 1 };
  function enqueue(type, data) {
    if (!started) return;
    queue.push(baseEvent(type, data));
    if (queue.length >= 12 || IMMEDIATE_FLUSH_TYPES[type]) {
      // Envoi immédiat (sendBeacon, non bloquant) pour les événements à forte valeur :
      // le direct admin les voit en ~1 s au lieu d'attendre le batch de 7 s.
      flush(false);
    } else {
      scheduleFlush();
    }
  }

  function scheduleFlush() {
    if (flushTimer) return;
    flushTimer = window.setTimeout(function () {
      flush(false);
    }, 7000);
  }

  function flush(useBeacon) {
    if (flushTimer) {
      window.clearTimeout(flushTimer);
      flushTimer = 0;
    }
    if (!queue.length || !visitorId || !sessionKey) return;
    var events = queue.splice(0, 30);
    var payload = JSON.stringify({
      shop: config.shop || "",
      visitorId: visitorId,
      sessionKey: sessionKey,
      userAgentHash: userAgentHash,
      landingPath: firstPath,
      referrerPath: referrerPath,
      sourceType: acquisition.sourceType,
      sourceName: acquisition.sourceName,
      referrerHost: acquisition.referrerHost,
      utmSource: acquisition.utmSource,
      utmMedium: acquisition.utmMedium,
      utmCampaign: acquisition.utmCampaign,
      utmContent: acquisition.utmContent,
      hasPaidClickId: acquisition.hasPaidClickId,
      events: events
    });
    if (useBeacon && window.navigator && typeof window.navigator.sendBeacon === "function") {
      var blob = new Blob([payload], { type: "application/json" });
      if (window.navigator.sendBeacon(endpoint, blob)) return;
    }
    fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: payload,
      keepalive: true
    }).catch(function () {});
  }

  function scrollPercent() {
    var doc = document.documentElement;
    var body = document.body;
    var scrollTop = window.pageYOffset || doc.scrollTop || body.scrollTop || 0;
    var height = Math.max(body.scrollHeight || 0, doc.scrollHeight || 0);
    var viewportHeight = window.innerHeight || doc.clientHeight || 0;
    if (height <= viewportHeight) return 100;
    return Math.max(0, Math.min(100, (scrollTop / (height - viewportHeight)) * 100));
  }

  function pageClickRatios(event) {
    var doc = document.documentElement;
    var body = document.body;
    var scrollLeft = window.pageXOffset || doc.scrollLeft || body.scrollLeft || 0;
    var scrollTop = window.pageYOffset || doc.scrollTop || body.scrollTop || 0;
    var pageWidth = Math.max(
      1,
      body.scrollWidth || 0,
      doc.scrollWidth || 0,
      window.innerWidth || doc.clientWidth || 0
    );
    var pageHeight = Math.max(
      1,
      body.scrollHeight || 0,
      doc.scrollHeight || 0,
      window.innerHeight || doc.clientHeight || 0
    );
    return {
      xRatio: Math.max(0, Math.min(1, (scrollLeft + event.clientX) / pageWidth)),
      yRatio: Math.max(0, Math.min(1, (scrollTop + event.clientY) / pageHeight))
    };
  }

  function captureScroll() {
    var percent = scrollPercent();
    [25, 50, 75, 90, 100].forEach(function (mark) {
      if (!scrollMarks[mark] && percent >= mark) {
        scrollMarks[mark] = true;
        enqueue("scroll_depth", { scrollPercent: mark, metadata: { action: "scroll_depth" } });
      }
    });
  }

  function captureClick(event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target || target.closest("input,textarea,select,[contenteditable='true']")) return;
    var whatsappIntent = isWhatsAppClick(target);
    var info = targetInfo(target, whatsappIntent);
    var href = info && info.href ? info.href : "";
    var type = "click";
    var eventId = "";
    var whatsappLeadRef = "";
    if (whatsappIntent) {
      type = "whatsapp_intent";
      eventId = randomId("evt_");
      whatsappLeadRef = buildWhatsappLeadRef();
      attachWhatsappLeadRefToClick(clickElement(target), whatsappLeadRef);
      trackMetaWhatsappContact(eventId, 0);
      sendWhatsappLeadClick(whatsappLeadRef, eventId);
    } else if (/\/cart(?:\/|$|\?)/.test(href) || target.closest("[name='add'],[data-add-to-cart],form[action*='/cart/add']")) {
      type = "cart_intent";
    }
    if (!whatsappIntent && (/\/pages\/appointments(?:\/|$|\?)/.test(href) || target.closest("[data-appointments-booking]"))) {
      type = "appointment_intent";
    }
    var ratios = pageClickRatios(event);
    enqueue(type, {
      eventId: eventId,
      xRatio: ratios.xRatio,
      yRatio: ratios.yRatio,
      target: info,
      isDeadClick: !href && type === "click" && !target.closest("button,summary,[role='button']"),
      metadata: whatsappLeadRef
        ? { action: type === "click" ? "click" : type, whatsappLeadRef: whatsappLeadRef }
        : { action: type === "click" ? "click" : type }
    });
  }

  function captureSubmit(event) {
    var form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!form) return;
    var action = String(form.getAttribute("action") || "");
    if (action.indexOf("/search") >= 0 || form.querySelector("input[type='search']")) {
      enqueue("search_submit", { target: targetInfo(form, false), metadata: { action: "search_submit" } });
    }
  }

  function handleCustomBehavior(event) {
    var detail = event && event.detail && typeof event.detail === "object" ? event.detail : {};
    var type = String(detail.type || "");
    if (!type) return;
    enqueue(type, {
      pageType: detail.pageType,
      productHandle: detail.productHandle,
      collectionHandle: detail.collectionHandle,
      metadata: detail.metadata || {}
    });
  }

  function startTracking() {
    if (started) return;
    if (sampleRate < 1 && Math.random() > sampleRate) return;
    visitorId = safeStorage(window.localStorage, "bfl_behavior_visitor", function () { return randomId("vis_"); });
    sessionKey = safeStorage(window.sessionStorage, "bfl_behavior_session", function () { return randomId("ses_"); });
    userAgentHash = hashUserAgent();
    restoreSessionAcquisition();
    started = true;
    enqueue("page_view", { metadata: { action: "page_view" } });
    captureScroll();
    document.addEventListener("click", captureClick, true);
    document.addEventListener("submit", captureSubmit, true);
    document.addEventListener("bfl:behavior", handleCustomBehavior);
    window.addEventListener("scroll", throttle(captureScroll, 500), { passive: true });
    window.addEventListener("beforeunload", function () { flush(true); });
    window.BFLVisitorBehavior = {
      track: function (type, metadata) {
        enqueue(type, { metadata: metadata || {} });
      },
      flush: function () {
        flush(false);
      }
    };
  }

  function waitForConsent() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== "function") {
      consentReadyTimeout = window.setTimeout(waitForConsent, 250);
      return;
    }
    window.clearTimeout(consentReadyTimeout);
    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (error) {
      if (error || !window.Shopify.customerPrivacy) return;
      if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
        startTracking();
      }
      document.addEventListener("visitorConsentCollected", function (event) {
        var detail = event && event.detail ? event.detail : {};
        if (detail.analyticsAllowed || window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
          startTracking();
        }
      });
      document.addEventListener("trackingConsentAccepted", startTracking);
    });
  }

  function throttle(fn, wait) {
    var timeout = 0;
    return function () {
      if (timeout) return;
      timeout = window.setTimeout(function () {
        timeout = 0;
        fn();
      }, wait);
    };
  }

  waitForConsent();
})();
